// Auto generated by ControleTool.ModelClassGenerator
import { inject } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { Helpers } from '../services/helpers';
import { SchoolViewModel } from './schoolview-model';
import { CourseViewModel } from './courseview-model';


export class NotificationViewModel {
    id: number = 0;
	title: string = null;
	content: string = null;
	schoolId: number | null = null;
	school: SchoolViewModel = null;
	courseId: number | null = null;
	course: CourseViewModel = null;
	showTeacher: boolean = false;
	showStudent: boolean = false;
	createdOn: Date = new Date();
	modifiedOn: Date | null = null;
	lastModifiedDate: Date = new Date();
	
	constructor(data: any = null) {
        
		if (data) {
			Helpers.mapProperties(data, this);
        }
        ValidationRules
			.ensure('title').displayName('Titel').required()
			.ensure('content').displayName('Inhoud').required()
			.on(this);
	}
}